import * as THREE from 'three';

export class WhiteBlackMaterial extends THREE.MeshStandardMaterial {
    constructor(viewer, textureName, color, params) {
        super({
            ...params,
            onBeforeCompile: (shader) => {
                shader.uniforms.color1 = {
                    value: new THREE.Color(color)
                };

                shader.fragmentShader = `
                    uniform vec3 color1;
                    ${shader.fragmentShader}
                `.replace(
                    `#include <map_fragment>`,
                    `
                    #include <map_fragment>
                    diffuseColor = vec4(
                        diffuseColor.r * color1.r,
                        diffuseColor.g * color1.g,
                        diffuseColor.b * color1.b,
                        opacity
                    );
                `);
            }
        });
    }
}
